import { makeUseAxios } from 'axios-hooks';
import axios from 'axios';
import { env } from 'Shared/constants/env';
import { makeApiHooks } from './makeHooks';

const axiosInstance = axios.create({
  baseURL: `${env.reznorHostname}/api/v3`,
});

axiosInstance.interceptors.response.use(
  response => response,
  error => {
    if (axios.isCancel(error)) {
      // don't throw any error in canceled request
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

const useAxios = makeUseAxios({
  axios: axiosInstance,
});

export const {
  useLazyApi: useLazyQuoteApi,
  useNewApi: useQuoteApi,
} = makeApiHooks(useAxios);
